import { render, staticRenderFns } from "./PxAssetsTable.vue?vue&type=template&id=aa1a922a&scoped=true"
import script from "./PxAssetsTable.vue?vue&type=script&lang=js"
export * from "./PxAssetsTable.vue?vue&type=script&lang=js"
import style0 from "./PxAssetsTable.vue?vue&type=style&index=0&id=aa1a922a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa1a922a",
  null
  
)

export default component.exports